module.exports = __webpack_public_path__ + "static/torba_100g-276f8b32932700dd6cd59e5ab9f77b8a.png";